import * as google from "./google";
import * as auth from "./auth";
import * as products from "./products";
import * as order from "./order";
import * as payment from "./payment";

export const APIs = { google, auth, products, order, payment };
